import './App.css';
import React, { useState } from 'react';
import IntroScreen from './Components/IntroScreen/IntroScreen';
import PuzzleReveal from './Components/PuzzleReveal/PuzzleReveal';
import Scene3D from './Components/Scene3D/Scene3D';
import ChatBot from './Components/ChatBot/ChatBot';
import ThemeToggle from './Components/ThemeToggle/ThemeToggle';
import Nav from './Components/Nav/Nav';
import Hero from './Components/Hero/Hero';
import About from './Components/About/About';
import Experience from './Components/Experience/Experience';
import Services from './Components/Services/Services';
import Portfolio from './Components/Portfolio/Portfolio';
import Contact from './Components/Contact/Contact';
import Footer from './Components/Footer/Footer';

const App = () => {
  const [introDone, setIntroDone] = useState(false);

  return (
    <>
      {!introDone && (
        <IntroScreen onComplete={() => setIntroDone(true)} />
      )}
      <ThemeToggle />
      <Scene3D />
      <PuzzleReveal show={introDone}>
        <Hero />
        <Nav />
        <About />
        <Experience />
        <Services />
        <Portfolio />
        <Contact />
        <Footer />
      </PuzzleReveal>
      <ChatBot />
    </>
  );
};

export default App;
